import { Injectable } from "@angular/core";
import { Types } from "../../models/picture/types";

export interface PictureFormatsStateInterface {
  types: Types;
}

@Injectable()
export class PictureFormatsActions {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/store/actions/picture-formats.actions.ts